var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-36 h-16 mx-auto md:mx-0 flex items-center"},[_c('img',{class:['object-contain', 'max-w-full', 'max-h-full', 'mx-auto', _vm.alignment === 'left' ? 'md:ml-0' : 'md:mx-auto'],attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }